var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("line",{"className":"a","x1":"2.25","y1":"18.003","x2":"21.75","y2":"18.003","key":1}),React.createElement("line",{"className":"a","x1":"2.25","y1":"12.003","x2":"21.75","y2":"12.003","key":2}),React.createElement("line",{"className":"a","x1":"2.25","y1":"6.003","x2":"21.75","y2":"6.003","key":3})]);
}

Burger.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Burger;

Burger.default = Burger;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/burger.svg
// module id = 1059
// module chunks = 0